import React from "react";
import NavBar from "./NavBar";
import NavBarHome from "./NavBarHome";


interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}

export function withNavbar<Props>(
    Component: React.ComponentType<Props>
) {
    return class WrappedComponent extends React.Component<Props> {
        render() {
            return (
                <>
                    <NavBar/>
                    <Component {...this.props}></Component>
                </>
            )

        }
    }
}

export function withNavbarHome<Props>(
    Component: React.ComponentType<Props>
) {
    return class WrappedComponent extends React.Component<Props> {
        render() {
            return (
                <>
                    <NavBarHome />
                    <Component {...this.props}></Component>
                </>
            )

        }
    }
}